<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.pais"
        ref="RkmDataTable"
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'pais_nome', label: 'Nome', name: 'cadastro_pais.nome', searchable: true, sortable: true},
            ]
        },
    },
    inject: ['repositories'],
}
</script>